import { gql } from '../../../apollo/__generated__';

export const UPDATE_EVENT = gql(`
  mutation UpdateEvent($updateEventInput: UpdateEventInput!) {
    updateEvent(updateEventInput: $updateEventInput) {
      id
      name
      type
      description
      lydiaLink
      checkAddress
      maxUsers
      startAt
      endAt
      isTargetEnabled
      isTinderEnabled
      arePaymentsEnabled
      areBedroomPaymentsEnabled
      place {
        id
      }
    }
  }
`);
